import { createContext, useContext, useEffect, useState } from "react";

export const LANGS = [
  { code: "it", label: "IT", locale: "it-IT", name: "Italiano" },
  { code: "en", label: "EN", locale: "en-GB", name: "English" },
  { code: "fr", label: "FR", locale: "fr-FR", name: "Français" },
  { code: "de", label: "DE", locale: "de-DE", name: "Deutsch" },
  { code: "es", label: "ES", locale: "es-ES", name: "Español" },
];

const it = {
  nav: { inventory: "Vetture", services: "Servizi", contact: "Contatti", call: "Chiama" },
  hero: {
    eyebrow: "Concessionaria · Udine · Via Cividina 99",
    lines: ["Auto scelte", "con cura,", "consegnate in Europa."],
    accent: 1,
    sub: "Selezioniamo vetture d'eccellenza e le consegniamo in tutta Europa, isole comprese, con la formula soddisfatti o rimborsati.",
    cta1: "Scopri le vetture",
    cta2: "Chiama lo showroom",
    stats: ["Europa + isole", "Soddisfatti o rimborsati", "Pagamenti anche in crypto"],
    scroll: "Scorri",
  },
  marquee: ["Consegna in tutta Europa", "Isole comprese", "Soddisfatti o rimborsati", "Pagamenti in criptovalute", "Showroom a Udine"],
  inv: {
    eyebrow: "Le nostre vetture",
    title: "In esposizione",
    titleAccent: "ora.",
    search: "Cerca marca o modello",
    allMakes: "Tutte le marche",
    allFuels: "Tutti i carburanti",
    sort: { newest: "Più recenti", priceAsc: "Prezzo crescente", priceDesc: "Prezzo decrescente", kmAsc: "Km più bassi" },
    empty: "Nuove vetture in arrivo. Chiamaci per conoscere le disponibilità in anteprima.",
    noResults: "Nessuna vettura corrisponde ai filtri.",
    count: "vetture",
    priceOnRequest: "Prezzo su richiesta",
    details: "Scopri",
    reset: "Azzera filtri",
  },
  status: { available: "Disponibile", reserved: "Prenotata", sold: "Venduta" },
  services: {
    eyebrow: "Perché CARS 99",
    title: "Comprare un'auto,",
    titleAccent: "senza pensieri.",
    s1t: "Consegna in tutta Europa",
    s1d: "Spediamo la tua vettura in ogni paese europeo, isole comprese, fino alla porta di casa.",
    s2t: "Soddisfatti o rimborsati",
    s2d: "Acquisti in totale serenità: se la vettura non ti soddisfa, ti rimborsiamo.",
    s3t: "Pagamenti anche in crypto",
    s3d: "Oltre ai metodi tradizionali accettiamo pagamenti in criptovalute. Chiamaci in sede per tutte le informazioni.",
    s4t: "Lo showroom a Udine",
    s4d: "Vieni a vedere le vetture dal vivo in Via Cividina 99. Per informazioni chiamaci in sede.",
  },
  contact: {
    eyebrow: "Contatti",
    title: "Parliamo della",
    titleAccent: "tua prossima auto.",
    note: "Per ogni informazione chiamaci in sede o scrivici: ti rispondiamo personalmente.",
    phone: "Telefono",
    email: "Email",
    address: "Showroom",
    directions: "Indicazioni stradali",
  },
  footer: {
    legal: "Dati aziendali",
    company: "Ragione sociale",
    nature: "Natura giuridica",
    natureVal: "Ditta individuale",
    vat: "Partita IVA",
    cf: "Codice fiscale",
    rea: "Numero REA",
    hq: "Sede legale",
    op: "Sede operativa",
    rights: "Tutti i diritti riservati.",
    admin: "Area riservata",
  },
  detail: {
    back: "Tutte le vetture",
    specs: "Scheda tecnica",
    description: "Descrizione",
    call: "Chiama per info",
    email: "Scrivi una email",
    photos: "foto",
    askTitle: "Ti interessa questa vettura?",
    askText: "Chiamaci in sede o scrivici: ti diamo tutte le informazioni, anche su consegna e pagamento.",
    notFound: "Vettura non trovata o non più disponibile.",
    emailSubject: "Informazioni su",
  },
  spec: { km: "Chilometri", year: "Anno", cv: "Potenza", kw: "kW", color: "Colore", vin: "Telaio (VIN)", plate: "Targa", fuel: "Carburante", gearbox: "Cambio", body: "Carrozzeria", doors: "Porte", seats: "Posti", engine_cc: "Cilindrata", owners: "Proprietari", registration: "Immatricolazione" },
  fuel: { petrol: "Benzina", diesel: "Diesel", hybrid: "Ibrida", phev: "Ibrida plug-in", electric: "Elettrica", lpg: "GPL", cng: "Metano" },
  gearbox: { manual: "Manuale", automatic: "Automatico", semi: "Sequenziale" },
  body: { sedan: "Berlina", suv: "SUV", coupe: "Coupé", cabrio: "Cabriolet", wagon: "Station wagon", hatch: "Compatta", van: "Monovolume", pickup: "Pick-up", other: "Altro" },
};

const en = {
  nav: { inventory: "Cars", services: "Services", contact: "Contact", call: "Call" },
  hero: {
    eyebrow: "Car dealership · Udine · Via Cividina 99",
    lines: ["Cars chosen", "with care,", "delivered across Europe."],
    accent: 1,
    sub: "We select exceptional cars and deliver them all over Europe, islands included, with a satisfied-or-refunded guarantee.",
    cta1: "Explore the cars",
    cta2: "Call the showroom",
    stats: ["Europe + islands", "Satisfied or refunded", "Crypto payments accepted"],
    scroll: "Scroll",
  },
  marquee: ["Delivery across Europe", "Islands included", "Satisfied or refunded", "Crypto payments", "Showroom in Udine"],
  inv: {
    eyebrow: "Our cars", title: "On display", titleAccent: "now.", search: "Search make or model", allMakes: "All makes", allFuels: "All fuels",
    sort: { newest: "Newest", priceAsc: "Price: low to high", priceDesc: "Price: high to low", kmAsc: "Lowest mileage" },
    empty: "New cars arriving soon. Call us to hear about availability first.", noResults: "No cars match your filters.",
    count: "cars", priceOnRequest: "Price on request", details: "Discover", reset: "Reset filters",
  },
  status: { available: "Available", reserved: "Reserved", sold: "Sold" },
  services: {
    eyebrow: "Why CARS 99", title: "Buying a car,", titleAccent: "worry-free.",
    s1t: "Delivery across Europe", s1d: "We ship your car to every European country, islands included, right to your door.",
    s2t: "Satisfied or refunded", s2d: "Buy with total peace of mind: if the car doesn't satisfy you, we refund you.",
    s3t: "Crypto payments accepted", s3d: "Alongside traditional methods we accept cryptocurrency payments. Call our showroom for details.",
    s4t: "Our showroom in Udine", s4d: "See the cars in person at Via Cividina 99. For information, call our showroom.",
  },
  contact: {
    eyebrow: "Contact", title: "Let's talk about", titleAccent: "your next car.",
    note: "For any information call our showroom or email us: we reply personally.",
    phone: "Phone", email: "Email", address: "Showroom", directions: "Get directions",
  },
  footer: {
    legal: "Company details", company: "Company name", nature: "Legal form", natureVal: "Sole proprietorship (Ditta individuale)",
    vat: "VAT number", cf: "Tax code", rea: "REA number", hq: "Registered office", op: "Operating office", rights: "All rights reserved.", admin: "Reserved area",
  },
  detail: {
    back: "All cars", specs: "Specifications", description: "Description", call: "Call for info", email: "Send an email", photos: "photos",
    askTitle: "Interested in this car?", askText: "Call our showroom or email us: we'll give you every detail, including delivery and payment.",
    notFound: "Car not found or no longer available.", emailSubject: "Information about",
  },
  spec: { km: "Mileage", year: "Year", cv: "Power", kw: "kW", color: "Colour", vin: "Chassis (VIN)", plate: "Plate", fuel: "Fuel", gearbox: "Gearbox", body: "Body", doors: "Doors", seats: "Seats", engine_cc: "Displacement", owners: "Owners", registration: "First registration" },
  fuel: { petrol: "Petrol", diesel: "Diesel", hybrid: "Hybrid", phev: "Plug-in hybrid", electric: "Electric", lpg: "LPG", cng: "CNG" },
  gearbox: { manual: "Manual", automatic: "Automatic", semi: "Sequential" },
  body: { sedan: "Sedan", suv: "SUV", coupe: "Coupé", cabrio: "Convertible", wagon: "Estate", hatch: "Hatchback", van: "MPV", pickup: "Pick-up", other: "Other" },
};

const fr = {
  nav: { inventory: "Véhicules", services: "Services", contact: "Contact", call: "Appeler" },
  hero: {
    eyebrow: "Concession automobile · Udine · Via Cividina 99",
    lines: ["Des voitures", "choisies avec soin,", "livrées en Europe."],
    accent: 1,
    sub: "Nous sélectionnons des voitures d'exception et les livrons partout en Europe, îles comprises, avec la formule satisfait ou remboursé.",
    cta1: "Découvrir les véhicules", cta2: "Appeler le showroom",
    stats: ["Europe + îles", "Satisfait ou remboursé", "Paiements en crypto acceptés"], scroll: "Défiler",
  },
  marquee: ["Livraison dans toute l'Europe", "Îles comprises", "Satisfait ou remboursé", "Paiements en cryptomonnaies", "Showroom à Udine"],
  inv: {
    eyebrow: "Nos véhicules", title: "En exposition", titleAccent: "maintenant.", search: "Rechercher marque ou modèle", allMakes: "Toutes les marques", allFuels: "Tous les carburants",
    sort: { newest: "Plus récents", priceAsc: "Prix croissant", priceDesc: "Prix décroissant", kmAsc: "Kilométrage le plus bas" },
    empty: "De nouveaux véhicules arrivent. Appelez-nous pour connaître les disponibilités en avant-première.", noResults: "Aucun véhicule ne correspond aux filtres.",
    count: "véhicules", priceOnRequest: "Prix sur demande", details: "Découvrir", reset: "Réinitialiser",
  },
  status: { available: "Disponible", reserved: "Réservée", sold: "Vendue" },
  services: {
    eyebrow: "Pourquoi CARS 99", title: "Acheter une voiture,", titleAccent: "sans souci.",
    s1t: "Livraison dans toute l'Europe", s1d: "Nous expédions votre voiture dans tous les pays européens, îles comprises, jusqu'à votre porte.",
    s2t: "Satisfait ou remboursé", s2d: "Achetez en toute sérénité : si la voiture ne vous satisfait pas, nous vous remboursons.",
    s3t: "Paiements en crypto acceptés", s3d: "En plus des moyens traditionnels, nous acceptons les paiements en cryptomonnaies. Appelez-nous pour plus d'informations.",
    s4t: "Notre showroom à Udine", s4d: "Venez voir les voitures au Via Cividina 99. Pour toute information, appelez le showroom.",
  },
  contact: {
    eyebrow: "Contact", title: "Parlons de", titleAccent: "votre prochaine voiture.",
    note: "Pour toute information, appelez le showroom ou écrivez-nous : nous répondons personnellement.",
    phone: "Téléphone", email: "Email", address: "Showroom", directions: "Itinéraire",
  },
  footer: {
    legal: "Informations légales", company: "Raison sociale", nature: "Forme juridique", natureVal: "Entreprise individuelle (Ditta individuale)",
    vat: "N° TVA", cf: "Code fiscal", rea: "Numéro REA", hq: "Siège social", op: "Siège opérationnel", rights: "Tous droits réservés.", admin: "Espace réservé",
  },
  detail: {
    back: "Tous les véhicules", specs: "Fiche technique", description: "Description", call: "Appeler pour info", email: "Envoyer un email", photos: "photos",
    askTitle: "Ce véhicule vous intéresse ?", askText: "Appelez le showroom ou écrivez-nous : nous vous donnerons toutes les informations, livraison et paiement compris.",
    notFound: "Véhicule introuvable ou plus disponible.", emailSubject: "Informations sur",
  },
  spec: { km: "Kilométrage", year: "Année", cv: "Puissance", kw: "kW", color: "Couleur", vin: "Châssis (VIN)", plate: "Immatriculation", fuel: "Carburant", gearbox: "Boîte", body: "Carrosserie", doors: "Portes", seats: "Places", engine_cc: "Cylindrée", owners: "Propriétaires", registration: "Mise en circulation" },
  fuel: { petrol: "Essence", diesel: "Diesel", hybrid: "Hybride", phev: "Hybride rechargeable", electric: "Électrique", lpg: "GPL", cng: "GNV" },
  gearbox: { manual: "Manuelle", automatic: "Automatique", semi: "Séquentielle" },
  body: { sedan: "Berline", suv: "SUV", coupe: "Coupé", cabrio: "Cabriolet", wagon: "Break", hatch: "Compacte", van: "Monospace", pickup: "Pick-up", other: "Autre" },
};

const de = {
  nav: { inventory: "Fahrzeuge", services: "Service", contact: "Kontakt", call: "Anrufen" },
  hero: {
    eyebrow: "Autohaus · Udine · Via Cividina 99",
    lines: ["Sorgfältig", "ausgewählte Autos,", "geliefert in ganz Europa."],
    accent: 1,
    sub: "Wir wählen außergewöhnliche Fahrzeuge aus und liefern sie in ganz Europa, Inseln inklusive, mit Zufriedenheitsgarantie oder Geld zurück.",
    cta1: "Fahrzeuge entdecken", cta2: "Showroom anrufen",
    stats: ["Europa + Inseln", "Zufrieden oder Geld zurück", "Krypto-Zahlungen akzeptiert"], scroll: "Scrollen",
  },
  marquee: ["Lieferung in ganz Europa", "Inseln inklusive", "Zufrieden oder Geld zurück", "Zahlung in Kryptowährungen", "Showroom in Udine"],
  inv: {
    eyebrow: "Unsere Fahrzeuge", title: "Jetzt", titleAccent: "ausgestellt.", search: "Marke oder Modell suchen", allMakes: "Alle Marken", allFuels: "Alle Kraftstoffe",
    sort: { newest: "Neueste", priceAsc: "Preis aufsteigend", priceDesc: "Preis absteigend", kmAsc: "Niedrigster Kilometerstand" },
    empty: "Neue Fahrzeuge treffen bald ein. Rufen Sie uns an, um die Verfügbarkeit vorab zu erfahren.", noResults: "Keine Fahrzeuge entsprechen den Filtern.",
    count: "Fahrzeuge", priceOnRequest: "Preis auf Anfrage", details: "Entdecken", reset: "Filter zurücksetzen",
  },
  status: { available: "Verfügbar", reserved: "Reserviert", sold: "Verkauft" },
  services: {
    eyebrow: "Warum CARS 99", title: "Ein Auto kaufen,", titleAccent: "ganz entspannt.",
    s1t: "Lieferung in ganz Europa", s1d: "Wir liefern Ihr Fahrzeug in jedes europäische Land, Inseln inklusive, bis vor Ihre Haustür.",
    s2t: "Zufrieden oder Geld zurück", s2d: "Kaufen Sie ganz entspannt: Wenn Sie mit dem Fahrzeug nicht zufrieden sind, erstatten wir Ihnen den Betrag.",
    s3t: "Krypto-Zahlungen akzeptiert", s3d: "Neben klassischen Zahlungsarten akzeptieren wir Kryptowährungen. Rufen Sie uns für Details an.",
    s4t: "Unser Showroom in Udine", s4d: "Besichtigen Sie die Fahrzeuge in der Via Cividina 99. Für Informationen rufen Sie uns an.",
  },
  contact: {
    eyebrow: "Kontakt", title: "Sprechen wir über", titleAccent: "Ihr nächstes Auto.",
    note: "Für alle Informationen rufen Sie den Showroom an oder schreiben Sie uns: Wir antworten persönlich.",
    phone: "Telefon", email: "E-Mail", address: "Showroom", directions: "Route planen",
  },
  footer: {
    legal: "Unternehmensdaten", company: "Firmenname", nature: "Rechtsform", natureVal: "Einzelunternehmen (Ditta individuale)",
    vat: "USt-IdNr.", cf: "Steuernummer", rea: "REA-Nummer", hq: "Rechtssitz", op: "Betriebssitz", rights: "Alle Rechte vorbehalten.", admin: "Interner Bereich",
  },
  detail: {
    back: "Alle Fahrzeuge", specs: "Technische Daten", description: "Beschreibung", call: "Für Infos anrufen", email: "E-Mail senden", photos: "Fotos",
    askTitle: "Interesse an diesem Fahrzeug?", askText: "Rufen Sie uns an oder schreiben Sie uns: Wir geben Ihnen alle Informationen, auch zu Lieferung und Zahlung.",
    notFound: "Fahrzeug nicht gefunden oder nicht mehr verfügbar.", emailSubject: "Informationen zu",
  },
  spec: { km: "Kilometerstand", year: "Baujahr", cv: "Leistung", kw: "kW", color: "Farbe", vin: "Fahrgestell (VIN)", plate: "Kennzeichen", fuel: "Kraftstoff", gearbox: "Getriebe", body: "Karosserie", doors: "Türen", seats: "Sitze", engine_cc: "Hubraum", owners: "Vorbesitzer", registration: "Erstzulassung" },
  fuel: { petrol: "Benzin", diesel: "Diesel", hybrid: "Hybrid", phev: "Plug-in-Hybrid", electric: "Elektro", lpg: "Autogas", cng: "Erdgas" },
  gearbox: { manual: "Schaltgetriebe", automatic: "Automatik", semi: "Sequenziell" },
  body: { sedan: "Limousine", suv: "SUV", coupe: "Coupé", cabrio: "Cabrio", wagon: "Kombi", hatch: "Kompaktwagen", van: "Van", pickup: "Pick-up", other: "Sonstige" },
};

const es = {
  nav: { inventory: "Vehículos", services: "Servicios", contact: "Contacto", call: "Llamar" },
  hero: {
    eyebrow: "Concesionario · Udine · Via Cividina 99",
    lines: ["Coches elegidos", "con cuidado,", "entregados en Europa."],
    accent: 1,
    sub: "Seleccionamos coches excepcionales y los entregamos en toda Europa, islas incluidas, con la fórmula satisfecho o reembolsado.",
    cta1: "Descubrir los vehículos", cta2: "Llamar al showroom",
    stats: ["Europa + islas", "Satisfecho o reembolsado", "Pagos en cripto aceptados"], scroll: "Desplazar",
  },
  marquee: ["Entrega en toda Europa", "Islas incluidas", "Satisfecho o reembolsado", "Pagos en criptomonedas", "Showroom en Udine"],
  inv: {
    eyebrow: "Nuestros vehículos", title: "En exposición", titleAccent: "ahora.", search: "Buscar marca o modelo", allMakes: "Todas las marcas", allFuels: "Todos los combustibles",
    sort: { newest: "Más recientes", priceAsc: "Precio ascendente", priceDesc: "Precio descendente", kmAsc: "Menos kilómetros" },
    empty: "Nuevos vehículos en camino. Llámanos para conocer la disponibilidad en primicia.", noResults: "Ningún vehículo coincide con los filtros.",
    count: "vehículos", priceOnRequest: "Precio a consultar", details: "Descubrir", reset: "Restablecer filtros",
  },
  status: { available: "Disponible", reserved: "Reservado", sold: "Vendido" },
  services: {
    eyebrow: "Por qué CARS 99", title: "Comprar un coche,", titleAccent: "sin preocupaciones.",
    s1t: "Entrega en toda Europa", s1d: "Enviamos tu coche a cualquier país europeo, islas incluidas, hasta la puerta de tu casa.",
    s2t: "Satisfecho o reembolsado", s2d: "Compra con total tranquilidad: si el coche no te satisface, te devolvemos el dinero.",
    s3t: "Pagos en cripto aceptados", s3d: "Además de los métodos tradicionales aceptamos pagos en criptomonedas. Llámanos para más información.",
    s4t: "Nuestro showroom en Udine", s4d: "Ven a ver los coches en persona en Via Cividina 99. Para información, llama al showroom.",
  },
  contact: {
    eyebrow: "Contacto", title: "Hablemos de", titleAccent: "tu próximo coche.",
    note: "Para cualquier información llama al showroom o escríbenos: respondemos personalmente.",
    phone: "Teléfono", email: "Email", address: "Showroom", directions: "Cómo llegar",
  },
  footer: {
    legal: "Datos de la empresa", company: "Razón social", nature: "Forma jurídica", natureVal: "Empresa individual (Ditta individuale)",
    vat: "NIF-IVA", cf: "Código fiscal", rea: "Número REA", hq: "Domicilio social", op: "Sede operativa", rights: "Todos los derechos reservados.", admin: "Área reservada",
  },
  detail: {
    back: "Todos los vehículos", specs: "Ficha técnica", description: "Descripción", call: "Llamar para info", email: "Enviar un email", photos: "fotos",
    askTitle: "¿Te interesa este vehículo?", askText: "Llama al showroom o escríbenos: te damos toda la información, también sobre entrega y pago.",
    notFound: "Vehículo no encontrado o ya no disponible.", emailSubject: "Información sobre",
  },
  spec: { km: "Kilometraje", year: "Año", cv: "Potencia", kw: "kW", color: "Color", vin: "Bastidor (VIN)", plate: "Matrícula", fuel: "Combustible", gearbox: "Cambio", body: "Carrocería", doors: "Puertas", seats: "Plazas", engine_cc: "Cilindrada", owners: "Propietarios", registration: "Matriculación" },
  fuel: { petrol: "Gasolina", diesel: "Diésel", hybrid: "Híbrido", phev: "Híbrido enchufable", electric: "Eléctrico", lpg: "GLP", cng: "GNC" },
  gearbox: { manual: "Manual", automatic: "Automático", semi: "Secuencial" },
  body: { sedan: "Berlina", suv: "SUV", coupe: "Coupé", cabrio: "Descapotable", wagon: "Familiar", hatch: "Compacto", van: "Monovolumen", pickup: "Pick-up", other: "Otro" },
};

export const DICT = { it, en, fr, de, es };
export const FUELS = Object.keys(it.fuel);
export const GEARBOXES = Object.keys(it.gearbox);
export const BODIES = Object.keys(it.body);

const I18nCtx = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("cars99_lang");
    return DICT[saved] ? saved : "it";
  });
  useEffect(() => {
    localStorage.setItem("cars99_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const locale = LANGS.find((l) => l.code === lang)?.locale || "it-IT";
  return <I18nCtx.Provider value={{ lang, setLang, t: DICT[lang], locale }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
